module.exports = __webpack_public_path__ + "static/media/office-building.209caaa7.png";